export default {
  user: null,
  loading: false,
  flats: [],
  isPageFormValid: false,
  currentFlatId: null
}
